<div class="cwan-gpt-chat-container">
  <cwan-gpt-chat class="cwan-gpt-chat"></cwan-gpt-chat>
</div>
